/*------------------------------------*\
    FEEDBACK REVIEW
\*------------------------------------*/
import Bugsnag from "@bugsnag/js";
import slugify from 'slugify';
// import axiosFeedbackInstance from "../../../axios-feedback-instance";

const axios = require('axios');
const FormData = require('form-data');

const formData = new FormData();

class FeedbackReview {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.feedbackStructure = [];

        const feedbackDataElement = document.getElementById('feedback-data');
        self.feedback = JSON.parse(feedbackDataElement.textContent);

        let feedbackSections = [];

        if (feedbackDataElement) {
            try {
                feedbackSections = self.feedback;
            } catch (err) {
                console.error("Failed to parse feedback data:", err);
            }
        }

        self.feedbackSections = feedbackSections;

        self.requiredFields = self.elem.querySelector('[data-required-fields]');
        self.feedbackReady = self.elem.querySelector('[data-feedback-ready]');
        self.formErrors = self.elem.querySelector('[data-form-error]');

        // Feedback submit button
        self.feedbackDefault = self.elem.querySelector('[data-feedback-default]');
        self.feedbackSubmitting = self.elem.querySelector('[data-feedback-submitting]');
    }

    init() {
        let self = this;

        self.populateHiddenFields();
        self.checkRequiredFields();
        self.submit();
    }

    checkRequiredFields() {
        let self = this;

        const hasMissingRequired = self.feedbackSections.some((section) => {
            if (section.required) {
                const key = slugify(section.title, { lower: true, replacement: '_' });
                return !localStorage.getItem(key);
            }

            return false;
        });

        if (hasMissingRequired) {
            self.requiredFields.classList.remove("d-none");
            self.feedbackReady.classList.add("d-none");
        } else {
            self.requiredFields.classList.add("d-none");
            self.feedbackReady.classList.remove("d-none");
        }
    }

    populateHiddenFields() {
        let self = this;

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a hidden input
            let markup = document.createElement('input');

            markup.setAttribute('type', 'hidden');
            markup.setAttribute('name', field.name);
            markup.setAttribute('value', field.value);

            self.elem.append(markup);
        });
    }

    // Get all items from local storage and convert
    // to array containing an object for each item
    getLocalStorage() {
        let self = this;

        let archive = [],
            keys = Object.keys(localStorage),
            i = 0,
            key;

        // Accept question data from local storage only.
        // Prevents extension keys from interfering with feedback data
        for (; (key = keys[i]); i++) {
            self.feedbackSections.forEach((section) => {
                section.questions.forEach((question) => {
                    self.buildStoredKey(archive, key, question);
                });
            });
        }

        return archive;
    }

    buildStoredKey(archive, key, question) {
        // if (key.includes(question.number)) {
        //     let data = JSON.parse(localStorage.getItem(key));

        //     if (data) {
        //         archive.push({
        //             name: key,
        //             label: data.label,
        //             value: data.value,
        //         });
        //     }
        // }

        if (key.includes(question.key)) {
            let data = JSON.parse(localStorage.getItem(key));

            if (data) {
                archive.push({
                    name: key,
                    label: data.label,
                    value: data.value,
                });
            }
        }
    }

    submit() {
        let self = this;

        // When the form submit button is clicked...
        self.elem.addEventListener("submit", (evt) => {
            // Prevent the form from submitting
            evt.preventDefault();

            self.sendFeedbackReport();
        });
    }

    async sendFeedbackReport() {
        let self = this;

        // Show loading spinner
        self.feedbackDefault.classList.add('d-none');
        self.feedbackSubmitting.classList.remove('d-none');

        self.feedbackSections.forEach((section) => {
            section.questions.forEach((question) => {
                self.buildFeedbackData(question);
            });
        });

        // Print out feedback form fields & responses on dev only
        if (process.env.ENVIRONMENT == 'dev') {
            for (const [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
        }

        // Return method based on feedback type (map/catcher)
        const feedbackType = `${process.env.FEEDBACK_TYPE}Feedback`;

        if (typeof this[feedbackType] === 'function') {
            this[feedbackType]();
        }
    }

    async mapFeedback() {
        let self = this;

        await axiosFeedbackInstance
            .post(`/api/feedback-form/${process.env.FEEDBACK_MAP_ID}`, formData)
            .then((response) => {
                // Hide loading spinner
                self.feedbackDefault.classList.remove('d-none');
                self.feedbackSubmitting.classList.add('d-none');

                // Redirect to success
                window.location.replace(self.feedbackSections.at(-1).url);

                // Clear local storage if not local setup
                if (process.env.ENVIRONMENT != 'dev') {
                    localStorage.clear();
                }
            })
            .catch((error) => {
                self.feedbackErrorHandler(error)
            });
    }

    catcherFeedback() {
        let self = this;
        const catcherId = self.elem.dataset.catcherId;

        if (!catcherId) {
            console.error('Missing data-catcher-id on feedback form');
            return;
        }

        self.elem.method = "POST";
        self.elem.action = `https://catcherv2.jfd.co.uk/f/${catcherId}`;
        self.elem.submit();

        if (process.env.ENVIRONMENT != 'dev') {
            localStorage.clear();
        }
    }

    buildFeedbackData(question) {
        let questionValue;
        let databaseColumn = question.key;

        // Check for question key in local storage which is not null or empty array
        if (
            localStorage.getItem(databaseColumn) &&
            (
                JSON.parse(localStorage.getItem(databaseColumn)).value != '' ||
                JSON.parse(localStorage.getItem(databaseColumn)).value.length
            )
        ) {
            if (Array.isArray(JSON.parse(localStorage.getItem(databaseColumn)).value)) {
                questionValue = JSON.parse(localStorage.getItem(databaseColumn)).value.join(', ');
            } else {
                questionValue = JSON.parse(localStorage.getItem(databaseColumn)).value.trim();
            }

            // Add question data to FormData()
            formData.append(databaseColumn, questionValue);
        }

        // Check if question has additional questions
        if (question.additionalQuestion) {
            let additionalQuestionValue;

            let additionalDatabaseColumn = `${databaseColumn}_additional_1`;

            if (localStorage.getItem(additionalDatabaseColumn) && localStorage.getItem(additionalDatabaseColumn).value != '') {
                additionalQuestionValue = JSON.parse(localStorage.getItem(additionalDatabaseColumn)).value.trim();

                // Add additional question data to FormData()
                formData.append(additionalDatabaseColumn, additionalQuestionValue);
            }
        }
    }

    // Show appropriate error message based on response
    feedbackErrorHandler(error) {
        let self = this;

        // Hide loading spinner
        self.feedbackDefault.classList.remove('d-none');
        self.feedbackSubmitting.classList.add('d-none');

        if (axios.isAxiosError(error)) {
            // Send error to Bugsnag
            Bugsnag.notify(error);

            // Declare error message to show to user
            let message = '';

            // Match error code to find message
            switch (error.code) {
                // No internet connection
                case 'ERR_NETWORK':
                    message = "Unable to connect to the server. Please check your internet connection and try again.";
                    break;
                // Page reloaded / lost connection
                case 'ERR_CANCELED':
                    message = "Your feedback submission was cancelled before it could complete. This may be due to your internet connection or the page was reloaded.";
                    break;
                // Fails server side field validation
                case 'ERR_BAD_REQUEST':
                    message = "We couldn't process your request because there seems to be an issue with the information provided. Please check all required fields and try again.";
                    break;
                // Otherwise...
                default:
                    message = "Sorry, there was an error trying to send your feedback, please check your submission and try again.";
            }

            // Append contact details to end of error message
            message = `${message} If the problem persists contact us.`;

            // Show error message to user
            self.formErrors.classList.remove('d-none');
            self.formErrors.innerHTML = message;
        }
    }
}

export default FeedbackReview;
